<template>
  <FormModal
    :visible="visible"
    :title="
      pessoaEdit ? 'Editar emissor de ordem' : 'Adicione um emissor de ordem'
    "
    :icon="require('@/assets/addRepresentante.png')"
    :loading="loading"
    confirm-label="Salvar"
    @update:visible="$emit('close')"
    @confirm="salvar"
    @cancel="$emit('close')"
  >
    <!-- Modo edição: formulário direto sem tabs -->
    <div v-if="pessoaEdit">
      <form @submit.prevent="salvar">
        <!-- SUBSECTION: Dados Pessoais -->
        <div class="form-subsection">
          <h4 class="form-subsection-title">
            <i class="fa fa-user"></i>
            Dados Pessoais
          </h4>

          <div class="form-grid-1">
            <div class="form-field">
              <InputNome
                v-model="novaPessoa.Nome"
                label="Nome"
                :required="true"
                :erro="erros.Nome"
              />
            </div>
          </div>

          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Tipo de Documento</label
              >
              <ModalSelect
                class="field"
                v-model="novaPessoa.TipoDocumento"
                @change="aoMudarTipoDocumento"
                :options="[{'id':'','descricao':'Selecione'},{'id':'CPF','descricao':'CPF'},{'id':'CNPJ','descricao':'CNPJ'},{'id':'CNH','descricao':'CNH'},{'id':'RNE','descricao':'RNE'}]"
                title="Tipo de documento"
                placeholder="Selecione"
              />
              <p v-if="erros.TipoDocumento" class="form-field-error">
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required">{{
                obterLabelDocumento
              }}</label>
              <input
                type="text"
                class="field"
                autocomplete="off"
                v-model="novaPessoa.CpfCnpj"
                v-mask="obterMascaraDocumento"
                :placeholder="obterPlaceholderDocumento"
                @blur="validarDocumento"
              />
              <p v-if="erros.CpfCnpj" class="form-field-error">
                Campo obrigatório
              </p>
              <p v-if="erroDocumento" class="form-field-error">
                {{ mensagemErroDocumento }}
              </p>
            </div>
          </div>

          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >E-mail</label
              >
              <input
                type="email"
                class="field"
                autocomplete="off"
                v-model="novaPessoa.Email"
                @blur="validarEmail"
              />
              <p v-if="erros.Email" class="form-field-error">
                {{ erros.Email }}
              </p>
            </div>
            <div class="form-field">
              <TelefoneInternacional
                v-model="novaPessoa.Telefone"
                name="Telefone"
                :required="true"
                :erro="erros.Telefone"
                @validate="onValidateTelefone"
              />
            </div>
          </div>

          <div v-if="exibirCargo" class="form-grid-1">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Cargo</label
              >
              <input
                type="text"
                class="field"
                autocomplete="off"
                v-model="novaPessoa.Cargo"
              />
              <p v-if="erros.Cargo" class="form-field-error">
                Campo obrigatório
              </p>
            </div>
          </div>

          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >É considerado US Person?</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    :value="false"
                    name="usPerson"
                    class="form-radio-input"
                    v-model="novaPessoa.UsPerson"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    :value="true"
                    name="usPerson"
                    class="form-radio-input"
                    v-model="novaPessoa.UsPerson"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
              </div>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >É uma Pessoa Exposta Politicamente?</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    :value="false"
                    name="politicamenteExposta"
                    class="form-radio-input"
                    v-model="novaPessoa.PoliticamenteExposta"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    :value="true"
                    name="politicamenteExposta"
                    class="form-radio-input"
                    v-model="novaPessoa.PoliticamenteExposta"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Modo adicionar: tabs normais -->
    <TabContainer
      v-else
      :tabs="tabs"
      :default-tab="abaAtiva"
      @tab-changed="abaAtiva = $event"
    >
      <!-- ABA: JÁ INFORMADO -->
      <template #jaInformado>
        <div class="form-subsection">
          <h4 class="form-subsection-title">
            <i class="fa fa-users"></i>
            Sócio, procurador ou responsável
          </h4>

          <div class="form-grid-1">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Selecione uma pessoa já cadastrada</label
              >
              <ModalSelect
                class="field"
                v-model="pessoaSelecionada"
                @change="habilitarSalvar"
                :options="[{ Guid: '', Nome: 'Selecione' }, ...(pessoasFiltradas || [])]"
                value-key="Guid"
                label-key="Nome"
                :custom-label="pessoa => pessoa.Guid === '' ? pessoa.Nome : pessoa.Nome + ' - ' + formatarCpf(pessoa.CpfCnpj)"
                title="Selecionar pessoa"
                placeholder="Selecione"
              />
              <p v-if="erros.pessoaSelecionada" class="form-field-error">
                Selecione uma pessoa
              </p>
            </div>
          </div>

          <div v-if="pessoaSelecionada" class="info-box">
            <i class="fa fa-info-circle"></i>
            Ao salvar, esta pessoa também será registrada como Emissor de Ordem.
          </div>
        </div>
      </template>

      <!-- ABA: NOVO -->
      <template #novo>
        <form @submit.prevent="salvar">
          <!-- SUBSECTION: Dados Pessoais -->
          <div class="form-subsection">
            <h4 class="form-subsection-title">
              <i class="fa fa-user"></i>
              Dados Pessoais
            </h4>

            <div class="form-grid-1">
              <div class="form-field">
                <InputNome
                  v-model="novaPessoa.Nome"
                  label="Nome"
                  :required="true"
                  :erro="erros.Nome"
                />
              </div>
            </div>

            <div class="form-grid-2">
              <div class="form-field">
                <label class="form-field-label form-field-label-required"
                  >Tipo de Documento</label
                >
                <ModalSelect
                  class="field"
                  v-model="novaPessoa.TipoDocumento"
                  @change="aoMudarTipoDocumento"
                  :options="[{'id':'','descricao':'Selecione'},{'id':'CPF','descricao':'CPF'},{'id':'CNH','descricao':'CNH'},{'id':'RNE','descricao':'RNE'}]"
                  title="Tipo de documento"
                  placeholder="Selecione"
                />
                <p v-if="erros.TipoDocumento" class="form-field-error">
                  Campo obrigatório
                </p>
              </div>
              <div class="form-field">
                <label class="form-field-label form-field-label-required">{{
                  obterLabelDocumento
                }}</label>
                <input
                  type="text"
                  class="field"
                  autocomplete="off"
                  v-model="novaPessoa.CpfCnpj"
                  v-mask="obterMascaraDocumento"
                  :placeholder="obterPlaceholderDocumento"
                  @blur="validarDocumento"
                />
                <p v-if="erros.CpfCnpj" class="form-field-error">
                  Campo obrigatório
                </p>
                <p v-if="erroDocumento" class="form-field-error">
                  {{ mensagemErroDocumento }}
                </p>
              </div>
            </div>

            <div class="form-grid-2">
              <div class="form-field">
                <label class="form-field-label form-field-label-required"
                  >E-mail</label
                >
                <input
                  type="email"
                  class="field"
                  autocomplete="off"
                  v-model="novaPessoa.Email"
                  @blur="validarEmail"
                />
                <p v-if="erros.Email" class="form-field-error">
                  {{ erros.Email }}
                </p>
              </div>
              <div class="form-field">
                <telefone-internacional
                  v-model="novaPessoa.Telefone"
                  label="Telefone"
                  name="Telefone"
                  @validate="onValidateTelefone"
                />
                <p v-if="erros.Telefone" class="form-field-error">
                  Campo obrigatório
                </p>
              </div>
            </div>

            <div v-if="exibirCargo" class="form-grid-1">
              <div class="form-field">
                <label class="form-field-label form-field-label-required"
                  >Cargo</label
                >
                <input
                  type="text"
                  class="field"
                  autocomplete="off"
                  v-model="novaPessoa.Cargo"
                />
                <p v-if="erros.Cargo" class="form-field-error">
                  Campo obrigatório
                </p>
              </div>
            </div>
          </div>

          <div class="form-subsection-divider"></div>

          <!-- SUBSECTION: Informações Regulatórias -->
          <div class="form-subsection">
            <h4 class="form-subsection-title">
              <i class="fa fa-shield"></i>
              Informações Regulatórias
            </h4>

            <div class="form-grid-1">
              <div class="form-field">
                <label class="form-field-label">Assinatura</label>
                <ModalSelect
                  class="field"
                  v-model="novaPessoa.Assinatura"
                  disabled
                  :options="[{'id':'1','descricao':'Não assina pela empresa'}]"
                  title="Assinatura"
                  placeholder="Selecione"
                />
                <p class="form-field-hint">
                  Emissores de ordem não assinam pela empresa
                </p>
              </div>
            </div>

            <div class="form-grid-2">
              <div class="form-field">
                <label class="form-field-label form-field-label-required"
                  >É considerado US Person?</label
                >
                <div class="form-radio-group">
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :value="false"
                      name="usPerson"
                      class="form-radio-input"
                      v-model="novaPessoa.UsPerson"
                    />
                    <span class="form-radio-label">Não</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :value="true"
                      name="usPerson"
                      class="form-radio-input"
                      v-model="novaPessoa.UsPerson"
                    />
                    <span class="form-radio-label">Sim</span>
                  </label>
                </div>
              </div>
              <div class="form-field">
                <label class="form-field-label form-field-label-required"
                  >É uma Pessoa Exposta Politicamente?</label
                >
                <div class="form-radio-group">
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :value="false"
                      name="politicamenteExposta"
                      class="form-radio-input"
                      v-model="novaPessoa.PoliticamenteExposta"
                    />
                    <span class="form-radio-label">Não</span>
                  </label>
                  <label class="form-radio-item">
                    <input
                      type="radio"
                      :value="true"
                      name="politicamenteExposta"
                      class="form-radio-input"
                      v-model="novaPessoa.PoliticamenteExposta"
                    />
                    <span class="form-radio-label">Sim</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
    </TabContainer>
  </FormModal>
</template>

<script>
import ModalSelect from "@/components/ModalSelect.vue";
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import FormModal from "@/components/FormModal.vue";
import TabContainer from "@/components/TabContainer.vue";
import InputNome from "@/components/form/InputNome.vue";
import TelefoneInternacional from "@/components/TelefoneInternacional.vue";
import documentoUtils, { isCNPJ } from "@/utils/documentoUtils";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";

export default {
  name: "ModalEmissorOrdem",
  components: {
    ModalSelect,
    FormModal,
    TabContainer,
    InputNome,
    TelefoneInternacional,
  },
  directives: {
    mask,
  },
  mixins: [emailValidatorMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pessoasDisponiveis: {
      type: Array,
      default: () => [],
    },
    pessoaEdit: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      exibirCargo: false,
      abaAtiva: "jaInformado",
      tabs: [
        { key: "jaInformado", label: "JÁ INFORMADO" },
        { key: "novo", label: "NOVO" },
      ],
      pessoaSelecionada: "",
      erros: {},
      erroDocumento: false,
      mensagemErroDocumento: "",
      telefoneValido: {},
      novaPessoa: {
        Id: null,
        Guid: "",
        ClienteId: null,
        Nome: "",
        Email: "",
        Cargo: "",
        CpfCnpj: "",
        TipoDocumento: "CPF",
        Telefone: "",
        Assinatura: 1, // Fixo: Não assina pela empresa
        UsPerson: false,
        PoliticamenteExposta: false,
        Tipo: "Pessoa autorizada emitir ordem",
      },
    };
  },
  computed: {
    ...mapGetters({
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    tabsVisiveis() {
      // Em modo edição, mostrar apenas a aba "NOVO"
      if (this.pessoaEdit) {
        return this.tabs.filter((tab) => tab.key === "novo");
      }
      return this.tabs;
    },
    pessoasFiltradas() {
      return (this.pessoasDisponiveis || []).filter(
        (pessoa) => pessoa.TipoDocumento !== "CNPJ",
      );
    },
    obterLabelDocumento() {
      return documentoUtils.obterLabelDocumento(
        this.novaPessoa.TipoDocumento || "CPF",
      );
    },
    obterMascaraDocumento() {
      return documentoUtils.obterMascaraDocumento(
        this.novaPessoa.TipoDocumento || "CPF",
      );
    },
    obterPlaceholderDocumento() {
      return documentoUtils.obterPlaceholderDocumento(
        this.novaPessoa.TipoDocumento || "CPF",
      );
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.pessoaEdit) {
            // Modo edição: preencher dados e ir para aba "novo"
            this.abaAtiva = "novo";
            this.novaPessoa = {
              ...this.novaPessoa,
              Id: this.pessoaEdit.Id || null,
              Guid: this.pessoaEdit.Guid || "",
              ClienteId: this.pessoaEdit.ClienteId || null,
              Nome: this.pessoaEdit.Nome || "",
              Email: this.pessoaEdit.Email || "",
              Cargo: this.pessoaEdit.Cargo || "",
              CpfCnpj: this.pessoaEdit.CpfCnpj || "",
              TipoDocumento: this.pessoaEdit.TipoDocumento || "CPF",
              Telefone: this.pessoaEdit.Telefone || "",
              Assinatura: this.pessoaEdit.Assinatura || 1,
              UsPerson: this.pessoaEdit.UsPerson || false,
              PoliticamenteExposta:
                this.pessoaEdit.PoliticamenteExposta || false,
              Tipo: "Pessoa autorizada emitir ordem",
            };
            if (this.novaPessoa.TipoDocumento === "CNPJ") {
              this.novaPessoa.TipoDocumento = "";
              this.novaPessoa.CpfCnpj = "";
            }
          } else {
            this.limpar();
          }
        });
      } else {
        this.limpar();
      }
    },
  },
  mounted() {
    this.exibirCargo =
      this.getConfiguracoes("Exibir cargo em representante")?.Valor !== "N";
  },
  methods: {
    formatarCpf(cpf) {
      if (!cpf) return "";
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    habilitarSalvar() {
      this.erros.pessoaSelecionada = false;
    },
    onValidateTelefone({ name, valid }) {
      this.telefoneValido[name] = valid;
    },
    validarEmail() {
      this.validarEmailGeneric(this.novaPessoa.Email, "Email", {
        obrigatorio: true,
      });
    },
    aoMudarTipoDocumento() {
      this.novaPessoa.CpfCnpj = "";
      this.erroDocumento = false;
      this.mensagemErroDocumento = "";
    },
    validarDocumento() {
      if (this.novaPessoa.CpfCnpj) {
        const resultado = documentoUtils.validarDocumentoCompleto(
          this.novaPessoa.CpfCnpj,
          this.novaPessoa.TipoDocumento || "CPF",
        );
        this.erroDocumento = !resultado.valido;
        this.mensagemErroDocumento = resultado.mensagem;
      }
    },
    validarJaInformado() {
      this.erros = {};
      if (!this.pessoaSelecionada) {
        this.erros.pessoaSelecionada = true;
        return false;
      }
      return true;
    },
    validarNovo() {
      this.erros = {};
      let valido = true;

      if (!this.novaPessoa.Nome) {
        this.erros.Nome = true;
        valido = false;
      }
      if (!this.novaPessoa.TipoDocumento) {
        this.erros.TipoDocumento = true;
        valido = false;
      }
      if (!this.novaPessoa.CpfCnpj || this.erroDocumento) {
        this.erros.CpfCnpj = true;
        valido = false;
      }
      if (
        !this.novaPessoa.Email ||
        Object.values(this.emailErros || {}).some((e) => e)
      ) {
        this.erros.Email = this.emailErros?.Email || "Campo obrigatório";
        valido = false;
      }
      if (!this.novaPessoa.Telefone || !this.telefoneValido?.Telefone) {
        this.erros.Telefone = true;
        valido = false;
      }
      if (this.exibirCargo && !this.novaPessoa.Cargo) {
        this.erros.Cargo = true;
        valido = false;
      }

      return valido;
    },
    async salvar() {
      if (this.abaAtiva === "jaInformado") {
        if (!this.validarJaInformado()) {
          this.$swal({
            icon: "warning",
            title: "Atenção",
            text: "Selecione uma pessoa para adicionar como emissor de ordem.",
          });
          return;
        }

        this.loading = true;
        this.$emit("submit", {
          guid: this.pessoaSelecionada,
          jaInformado: true,
        });
      } else {
        if (
          (this.pessoaEdit && this.novaPessoa.TipoDocumento === "CNPJ") ||
          (!this.pessoaEdit && isCNPJ(this.novaPessoa.CpfCnpj))
        ) {
          this.$alertWarning(
            "Documento inválido",
            "O tipo de documento CNPJ não é permitido para o emissor. Selecione CPF, CNH ou RNE antes de salvar."
          );
          return;
        }
        if (!this.validarNovo()) {
          this.$swal({
            icon: "warning",
            title: "Atenção",
            text: "Preencha todos os campos obrigatórios.",
          });
          return;
        }

        this.loading = true;
        this.$emit("submit", {
          ...this.novaPessoa,
          jaInformado: false,
        });
      }
    },
    resetarLoading() {
      this.loading = false;
    },
    limpar() {
      this.abaAtiva = "jaInformado";
      this.pessoaSelecionada = "";
      this.novaPessoa = {
        Guid: "",
        Nome: "",
        Email: "",
        Cargo: "",
        CpfCnpj: "",
        TipoDocumento: "CPF",
        Telefone: "",
        Assinatura: 1,
        UsPerson: false,
        PoliticamenteExposta: false,
        Tipo: "Pessoa autorizada emitir ordem",
      };
      this.erros = {};
      this.erroDocumento = false;
      this.mensagemErroDocumento = "";
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.info-box {
  margin-top: 1rem;
  padding: 0.875rem 1rem;
  background-color: #eff6ff;
  border-left: 4px solid #3b82f6;
  border-radius: 0.375rem;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;

  i {
    color: #3b82f6;
    font-size: 1.125rem;
    margin-top: 0.125rem;
  }
}

.form-field-hint {
  font-size: 0.875rem;
  color: #6b7280;
  margin-top: 0.375rem;
}
</style>
